import { MuiThemeProvider } from '@material-ui/core/styles';
import CustomIconButton from 'components/CustomIconButton/CustomIconButton';
import CloseIcon from 'components/Icons/CloseIcon';
import { SnackbarKey, SnackbarProvider, useSnackbar } from 'notistack';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import styles from './App.scss';
import { Layout } from './components/Layout';
import { getCustomMaterialTheme } from './config/MaterialTheme';
import { EnvironmentType, loadEnvironments } from './library/Apis';
import PageRoutes from './pages/PageRoutes';
import { getStore } from './store';
import RouteChangeTrackerNotifications from 'components/RouteNotification';
import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';
import { useEffect } from 'react';
import RouteAnalyticsTracker from 'components/RouteAnalytics';
import { initGTM } from 'utils/AnalyticsGTM';

const rootClassName = styles.rootClassName;

const SnackbarActionButton = ({ snack }: { snack: SnackbarKey }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <CustomIconButton
      theme="transluscent"
      onClick={() => closeSnackbar(snack)}
      icon={<CloseIcon />}
    />
  );
};

export default function App() {
  const env = window.env as EnvironmentType;

  useEffect(() => {
    loadEnvironments(() => "");
  }, []);
  
  useEffect(() => {
    initGTM();
  }, [env]);

  if (!env) {
    return (
      <div className={rootClassName}>
        <LoaderGlobal />
      </div>
    );
  }

  return (
    <MuiThemeProvider theme={getCustomMaterialTheme()}>
      <Provider store={getStore(env)}>
        <BrowserRouter>
          <RouteChangeTrackerNotifications />
          <RouteAnalyticsTracker />
          <SnackbarProvider
            action={(k) => <SnackbarActionButton snack={k} />}
            preventDuplicate
            autoHideDuration={4000}
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            classes={{containerAnchorOriginTopRight: 'snackbar-container-top-right'}}
          >
              <Layout>
                <PageRoutes />
              </Layout>
          </SnackbarProvider>
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  );
}
